import Image from 'next/image';

/**
 * -----------------------------------------------------------------------------
 * WIP - This is to show the hero image slider for features that are to be tested.
 */
export function HeroImageSlider() {
  return (
    <div className="flex items-center justify-center">
      <div
        className="
          border-primary-50 bg-primary-300 -ml-[72px] -mr-[72px] flex h-56 w-56
          items-center justify-center overflow-y-hidden rounded-full
          border-8
        "
      >
        <Image
          alt="Back of mobile"
          className="h-auto w-auto pt-20"
          height={162.76}
          priority
          src="/images/assessment-images/BACK.png"
          width={154}
        />
      </div>
      <div
        className="
          border-primary-50 z-10 flex h-56 w-56 items-center justify-center overflow-hidden
          rounded-full border-8 bg-indigo-50
        "
      >
        <Image
          alt="Phone screen"
          height={218}
          priority
          src="/images/assessment-images/phone-screen.png"
          width={218}
        />
      </div>
      <div
        className="
          border-primary-50 bg-primary-300 -ml-20 -mr-20 flex h-56 w-56 items-center
          justify-center overflow-y-hidden rounded-full border-8
        "
      >
        <Image
          alt="Front finger device"
          className="pl-8 mix-blend-multiply"
          height={162.76}
          src="/images/assessment-images/frontFingerDevice.png"
          width={154}
        />
      </div>
    </div>
  );
}
